(() => {
  'use strict';

  if (window.__SQ_UNIVERSAL_EXPANDED_BAG_V6__) return;
  window.__SQ_UNIVERSAL_EXPANDED_BAG_V6__ = true;
  window.__SQ_UNIVERSAL_EXPANDED_BAG_V4__ = true;

  const OPEN_SELECTOR = [
    '.sq-universal-bag','.sq-universal-card-trigger','[data-sq-source-bag]','[data-lcs-universal-choose]',
    '[data-pick-quick-open]','[data-sq-universal-expanded-open]','[data-lcs-favorite-expand]','[data-lcs-bag-hover]',
    '[data-lcs-card-open]','[data-sq-collection-expanded-open]','[data-sqyml2-expand]','[data-lcs-recommend-expand]',
    '[data-sq-favorite-expanded-open]','button[aria-label*="Choose" i]',
    'quick-add-component[data-quick-add-button="choose"] .quick-add__button'
  ].join(',');

  const CARD_SELECTOR = [
    '[data-sq-universal-card]','[data-sq-rebuilt-card]','[data-lcs-favorite-card]','[data-lcs-card]',
    '[data-lcs-recommend-card]','[data-sqyml2-card]','[data-product-slider-card]','[data-product-card]',
    '[data-product-id]','.sq-smart-picks__item','.product-slider-belt-card','.product-card',
    '.premium-recommend-card-shell','product-card'
  ].join(',');

  const pending = new WeakSet();
  const clean = value => String(value ?? '').trim();
  const first = (...values) => values.map(clean).find(Boolean) || '';
  let controllerPromise = null;
  let observerFrame = 0;
  const observerRoots = new Set();
  let suppressSearchClickUntil = 0;
  let suppressSearchButton = null;

  function findController() {
    if (window.SQUniversalExpandedCard?.openExpanded) return window.SQUniversalExpandedCard;
    for (const host of document.querySelectorAll('[data-lcs-expanded-controller],[data-lcs-favorites-page]')) {
      const instance = host.__lcsFavoritesPage || host.__lcsExpandedController || host.__sqExpandedController;
      if (instance?.openExpanded) {
        window.SQUniversalExpandedCard = instance;
        return instance;
      }
    }
    return null;
  }

  function getController() {
    const immediate = findController();
    if (immediate) return Promise.resolve(immediate);
    if (controllerPromise) return controllerPromise;
    controllerPromise = new Promise(resolve => {
      const started = performance.now();
      const check = () => {
        const instance = findController();
        if (instance || performance.now() - started > 1600) {
          controllerPromise = null;
          resolve(instance || null);
          return;
        }
        setTimeout(check, 25);
      };
      check();
    });
    return controllerPromise;
  }

  function sourceFor(button) {
    return button?.closest?.(CARD_SELECTOR) ||
      button?.closest?.('[data-product-handle],[data-product-url],[data-product-id]') ||
      button?.closest?.('quick-add-component')?.parentElement ||
      button?.parentElement || null;
  }

  function quickFor(button, source) {
    return button?.closest?.('quick-add-component') || source?.querySelector?.('quick-add-component') || null;
  }

  function productAnchor(button, source, quick) {
    const candidates = [
      button?.closest?.('a[href*="/products/"]'),
      source?.querySelector?.('a[href*="/products/"]'),
      quick?.querySelector?.('a[href*="/products/"]'),
      button?.parentElement?.querySelector?.('a[href*="/products/"]'),
      button?.closest?.('article,li,div')?.querySelector?.('a[href*="/products/"]')
    ];
    return candidates.find(anchor => anchor instanceof HTMLAnchorElement) || null;
  }

  function handleFromHref(href) {
    const raw = clean(href);
    if (!raw.includes('/products/')) return '';
    return clean(raw.split('/products/')[1]?.split(/[?#/]/)[0]);
  }

  function productHandle(button, source, quick, anchor) {
    return first(
      button?.dataset.productHandle,button?.dataset.handle,
      quick?.dataset.productHandle,source?.dataset.productHandle,source?.dataset.handle,
      handleFromHref(button?.dataset.productUrl),handleFromHref(quick?.dataset.productUrl),
      handleFromHref(source?.dataset.productUrl),handleFromHref(anchor?.getAttribute('href'))
    );
  }

  function selectedVariant(button, source, quick, anchor) {
    let urlVariant = '';
    try { urlVariant = new URL(anchor?.href || '', location.origin).searchParams.get('variant') || ''; } catch (_) {}
    return first(
      button?.dataset.selectedVariantId,button?.dataset.variantId,
      quick?.dataset.selectedVariantId,quick?.dataset.variantId,
      source?.dataset.selectedVariantId,source?.dataset.variantId,
      quick?.querySelector?.('input[name="id"]')?.value,source?.querySelector?.('input[name="id"]')?.value,
      source?.querySelector?.('[data-variant-id].is-active,[data-variant-id][aria-pressed="true"]')?.dataset.variantId,
      urlVariant
    );
  }

  function productImage(button, source, quick) {
    const image = source?.querySelector?.('.sq-universal-card__image,.product-slider-belt-card__image,.product-card__image img,.card__media img,img:not(.product-card-variant-belt__image)') ||
      quick?.querySelector?.('img');
    return first(button?.dataset.productImage,quick?.dataset.productImage,source?.dataset.productImage,image?.currentSrc,image?.src);
  }

  function productUrl(button, source, quick, anchor, handle, variantId) {
    const raw = first(button?.dataset.productUrl,quick?.dataset.productUrl,source?.dataset.productUrl,anchor?.getAttribute('href'),handle ? `/products/${handle}` : '');
    if (!raw) return '';
    try {
      const url = new URL(raw, location.origin);
      if (variantId) url.searchParams.set('variant', variantId);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) { return raw; }
  }

  function itemFor(button, source, quick) {
    const anchor = productAnchor(button, source, quick);
    const handle = productHandle(button, source, quick, anchor);
    const variantId = selectedVariant(button, source, quick, anchor);
    const productId = first(button?.dataset.productId,quick?.dataset.productId,source?.dataset.productId);
    const titleNode = source?.querySelector?.('h3,h4,[ref="productTitleLink"],.product-card__title,.card__heading,[data-product-title]');
    const priceNode = source?.querySelector?.('[data-product-card-price],.product-slider-belt-card__price,.product-card__price,.price');
    const title = first(button?.dataset.productTitle,quick?.dataset.productTitle,source?.dataset.productTitle,anchor?.getAttribute('aria-label'),anchor?.getAttribute('title'),titleNode?.textContent);
    const price = first(button?.dataset.productPrice,quick?.dataset.productPrice,source?.dataset.productPrice,priceNode?.textContent);
    const image = productImage(button, source, quick);
    const now = new Date().toISOString();
    return {
      key:`universal-${productId || handle}|${variantId || 'default'}`,
      productId,variantId,handle,productHandle:handle,title,
      url:productUrl(button, source, quick, anchor, handle, variantId),
      image,imageUrl:image,price,compareAtPrice:'',options:[],selectedOptions:[],optionsWithValues:[],variants:[],media:[],
      available:true,color:'',size:'',quantity:Math.max(1,Number(quick?.querySelector?.('input[name="quantity"]')?.value || 1)),
      addedAt:now,updatedAt:now
    };
  }

  function normalizeBag(button) {
    if (!(button instanceof HTMLElement) || button.closest('[data-lcs-favorite-expanded]')) return;
    const label = button.querySelector('.sq-universal-bag__label,[data-sq-bag-label]');
    if (label && label.textContent.trim().toUpperCase() !== 'CHOOSE') label.textContent = 'CHOOSE';
    if (button.classList.contains('sq-universal-bag')) button.setAttribute('data-sq-universal-expanded-open','');
  }

  function normalizeBags(root=document) {
    if (root instanceof Element && root.matches(OPEN_SELECTOR)) normalizeBag(root);
    root.querySelectorAll?.(OPEN_SELECTOR).forEach(normalizeBag);
  }

  function resetBag(button) {
    if (!(button instanceof HTMLElement)) return;
    button.setAttribute('aria-expanded','false');
    button.classList.remove('sq-bag-expanded','sq-bag-pill-expanded','sq-universal-bag-expanded','sq-bag-card-active','is-open','is-active');
  }

  function closeCompetingPanels(keepModal) {
    document.querySelectorAll('.pick-quick-panel').forEach(panel => { panel.hidden=true; panel.setAttribute('aria-hidden','true'); });
    try { document.getElementById('quick-add-dialog')?.querySelector('dialog[open]')?.close(); } catch (_) {}
    document.querySelectorAll('[data-lcs-favorite-expanded]:not([hidden])').forEach(modal => {
      if (modal !== keepModal) { modal.hidden=true; modal.setAttribute('aria-hidden','true'); }
    });
  }

  function syncCard(source,item) {
    if (!(source instanceof Element) || !item) return;
    const variantId=clean(item.variantId);
    if (variantId) {
      source.dataset.selectedVariantId=variantId;
      source.querySelectorAll('input[name="id"]').forEach(input=>{ input.value=variantId; });
    }
    const src=clean(typeof item.image==='string'?item.image:item.image?.src);
    const image=source.querySelector('.sq-universal-card__image,.product-slider-belt-card__image,.product-card__image img,.card__media img');
    if (image instanceof HTMLImageElement && src) { image.src=src; image.removeAttribute('srcset'); }
  }

  async function openFrom(button) {
    if (!(button instanceof HTMLElement) || pending.has(button)) return false;
    pending.add(button);
    normalizeBag(button);
    button.classList.add('sq-bag-expanded');
    const source=sourceFor(button);
    const quick=quickFor(button,source);
    try {
      const item=itemFor(button,source,quick);
      if (!item.handle) throw new Error('Product handle not found for this shopping bag.');
      const instance=await getController();
      if (!instance) throw new Error('Expanded-card controller not found.');
      const host=instance.section || instance.r || document.querySelector('[data-lcs-expanded-controller]');
      const modal=host?.querySelector?.('[data-lcs-favorite-expanded]') || document.querySelector('[data-lcs-favorite-expanded]');
      if (modal) { modal.id ||= 'lcs-universal-expanded-card'; button.setAttribute('aria-controls',modal.id); }
      closeCompetingPanels(modal);
      window.__lcsExpandedReturnFocus=button;
      button.setAttribute('aria-expanded','true');
      const result=instance.openExpanded(item);
      Promise.resolve(result).then(()=>syncCard(source,instance.activeExpandedItem || item)).catch(()=>{});
      return true;
    } catch(error) {
      console.error('[Serein Queen universal shopping bag]',error);
      resetBag(button);
      return false;
    } finally { pending.delete(button); }
  }

  function searchDialogFor(button) {
    return button?.closest?.('#search-modal')?.querySelector?.('dialog') || null;
  }

  function closeSearchDialog(dialog) {
    if (!(dialog instanceof HTMLDialogElement)) return;
    const body=document.body;
    const wasFixed=getComputedStyle(body).position==='fixed';
    const top=Number.parseFloat(body.style.top || '');
    const y=wasFixed && Number.isFinite(top) && top<0 ? Math.abs(top) : window.scrollY;
    try { if (dialog.open) dialog.close(); } catch (_) {}
    dialog.classList.remove('dialog-closing');
    dialog.style.animation='';
    document.documentElement.removeAttribute('scroll-lock');
    if (wasFixed) {
      body.style.position=''; body.style.top=''; body.style.width='';
      requestAnimationFrame(()=>window.scrollTo({top:y,left:window.scrollX,behavior:'auto'}));
    }
  }

  window.addEventListener('pointerdown',event=>{
    const button=event.target instanceof Element?event.target.closest(OPEN_SELECTOR):null;
    if (!button || button.closest('[data-lcs-favorite-expanded]') || !button.closest('#search-modal')) return;
    if (button.matches('.quick-add__button--add,button[type="submit"][name="add"]')) return;
    event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
    suppressSearchClickUntil=Date.now()+700;
    suppressSearchButton=button;
    document.dispatchEvent(new CustomEvent('sq:search:expanded-handoff',{detail:{button}}));
    const dialog=searchDialogFor(button);
    closeSearchDialog(dialog);
    queueMicrotask(()=>void openFrom(button));
  },{capture:true,passive:false});

  window.addEventListener('click',event=>{
    const button=event.target instanceof Element?event.target.closest(OPEN_SELECTOR):null;
    if (!button || button.closest('[data-lcs-favorite-expanded]')) return;
    if (button.matches('.quick-add__button--add,button[type="submit"][name="add"]')) return;
    event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
    if (button===suppressSearchButton && Date.now()<suppressSearchClickUntil) return;
    void openFrom(button);
  },true);

  document.addEventListener('pointerenter',event=>{ const button=event.target instanceof Element?event.target.closest('.sq-universal-bag'):null; button?.classList.add('sq-bag-expanded'); },true);
  document.addEventListener('pointerleave',event=>{ const button=event.target instanceof Element?event.target.closest('.sq-universal-bag'):null; if(button&&button.getAttribute('aria-expanded')!=='true')button.classList.remove('sq-bag-expanded'); },true);
  document.addEventListener('focusin',event=>{ if(event.target instanceof Element)event.target.closest('.sq-universal-bag')?.classList.add('sq-bag-expanded'); },true);
  document.addEventListener('focusout',event=>{ const button=event.target instanceof Element?event.target.closest('.sq-universal-bag'):null; if(button&&button.getAttribute('aria-expanded')!=='true')button.classList.remove('sq-bag-expanded'); },true);

  function queueNormalize(root){ if(root instanceof Element)observerRoots.add(root); if(observerFrame)return; observerFrame=requestAnimationFrame(()=>{observerFrame=0;const roots=[...observerRoots];observerRoots.clear();roots.forEach(normalizeBags);}); }
  const start=()=>{
    normalizeBags(document); void getController();
    const main=document.getElementById('MainContent');
    if(main)new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node instanceof Element)queueNormalize(node);}))).observe(main,{childList:true,subtree:true});
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
  document.addEventListener('shopify:section:load',event=>normalizeBags(event.target));
  window.SQUniversalExpandedBag={openFrom,getController,normalizeBags};
})();
